import { TVerifyTokenBody } from '../utils/types/agrocraftArtisan';
import { updateToken } from '../reduxActions/tokenSlice';
import { Token } from '../utils/types';
import { emptySplitApi } from './base/emptySplitApi';

export const authUserService =
  emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      verifyToken: builder.query<Token, TVerifyTokenBody>({
        query: (data) => ({
          url: 'authenticate',
          method: 'POST',
          data,
        }),
        async onQueryStarted(
          args,
          { dispatch, queryFulfilled }
        ) {
          queryFulfilled
            .then(({ data }: { data: Token }) => {
              localStorage.setItem(
                'authToken',
                JSON.stringify(data)
              );
              dispatch(updateToken(data));
            })
            .catch((error) => error);
        },
      }),
    }),
  });

export const { useLazyVerifyTokenQuery } = authUserService;
